module.exports = __webpack_public_path__ + "media/images/webpage/coupons/coupon/howto-step1-8422c707642bd8b9c0e26ca1a7081120.svg";